// extracted by mini-css-extract-plugin
export default {"loader":"minimal-loader_loader__TFOTx","spin":"minimal-loader_spin__oF2bT"};